import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map, switchMap, take, tap } from 'rxjs';
import { AppRoutes } from 'src/app/app-routes';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { StepperService } from 'src/app/services/stepper/stepper.service';
import { StoreService } from 'src/app/services/store/store.service';
import { QUERY_PARAMS, Steps } from 'src/app/utils/constants';

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
	readonly steps = Steps;
	readonly stepActive$ = this.stepperService.stepActive$;
	readonly loader$ = this.loaderService.loader$;

	constructor(
		private readonly loaderService: LoaderService,
		private readonly stepperService: StepperService,
		private readonly storeService: StoreService,
		private readonly gtmservice: GtmService,
		private readonly route: ActivatedRoute,
		private readonly router: Router
	) {}

	ngOnInit(): void {
		this.initFlow();
	}

	private initFlow(): void {
		this.route.queryParamMap
			.pipe(
				take(1),
				map(params => params.get(QUERY_PARAMS.PRODUCT)),
				filter((product): product is string => product != null && product.trim().length > 0),
				tap(product => this.gtmservice.setExtras({ flujo: product })),
				switchMap(product => this.storeService.initialParameters(product)),
				tap(() => this.router.navigate([AppRoutes.COMPANY_DATA]))
			)
			.subscribe();
	}
}
